import styled, { css } from 'styled-components';
import { gray10, gray45, gray95, gray60, spacer4, spacer12, screenXsMax } from '@spotify-internal/encore-foundation';
import { typeStyleCta4 } from "../../styles";

var isDarkTheme = function isDarkTheme(props) {
  return props.theme.tableHeaderCell === 'dark';
};

export default styled.th.withConfig({
  displayName: "TableHeaderCell",
  componentId: "sc-1tfoxgx-0"
})(["", ";", ";padding:", ";text-align:", ";vertical-align:bottom;&:first-child{@media (max-width:", "){padding-left:", ";}}&:last-child{@media (max-width:", "){padding-right:", ";}}", ";"], typeStyleCta4(), function (props) {
  return isDarkTheme(props) ? css(["color:", ";"], props.active ? gray95 : gray60) : "\n      color: ".concat(props.active ? gray10 : gray45, ";\n  ");
}, spacer12, function (props) {
  return props.align;
}, screenXsMax, spacer4, screenXsMax, spacer4, function (props) {
  return props.selectable && css(["cursor:default;&:hover{color:", ";}"], isDarkTheme(props) ? gray95 : gray10);
});